import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerifyPhoneNumberModule } from '@shared/verify-phone-number/verify-phone-number.module';

import { UserRoutingModule } from './user-routing.module';
import { UserUpdateComponent } from './pages';
import { UserFormComponent } from './components';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';

@NgModule({
  declarations: [UserUpdateComponent, UserFormComponent],
  imports: [CommonModule, UserRoutingModule, VerifyPhoneNumberModule, MutualModule, PipesSharedModule, CustomModalModule, InputPhoneModule],
})
export class UserModule {}
